import roROMessages from 'languages/console-strings-ro-RO.json';

const AppLocale = {
  'ro-RO': {
    messages: roROMessages,
    locale: 'ro-RO',
  },
};

export default AppLocale;
